<template>
  <div class="work-type-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("system.workType.Return_to_workType_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" label-width="100">
            <FormItem :label="$t('system.workType.name')">
              <Input v-if="id == 0" class="info" v-model="name" :placeholder="$t('system.workType.please_enter')" ></Input>
              <Input v-if="id != 0" class="info" v-model="name" :placeholder="$t('system.workType.please_enter')" disabled ></Input>
            </FormItem>
            <FormItem :label="$t('system.workType.Sorting')">
              <Input class="info" v-model="Sorting" :placeholder="$t('system.workType.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.workType.outputValid')">
              <Select class="info" v-model="outputValid" :value="outputValid">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('system.workType.monopoly')">
              <Select class="info" v-model="monopoly" value="0">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('system.workType.maintain')">
              <Select class="info" v-model="maintain" :value="maintain">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('system.workType.display')">
              <Select class="info" v-model="display" :value="display">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('system.workType.malfunction')">
              <Select class="info" v-model="malfunction" :value="malfunction">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem>
            <!-- <FormItem :label="$t('system.workType.warn')">
              <Select class="info" v-model="warn" :value="warn">
                <Option :value="Number(0)" :key="Number(0)">{{$t("system.workType.no")}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t("system.workType.yes")}}</Option>
              </Select>
            </FormItem> -->
            <FormItem :label="$t('system.workType.remark')">
              <Input class="info" v-model="remark" :placeholder="$t('system.workType.please_enter')"></Input>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("system.workType.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'WorkTypeEdit',
  data () {
    return {
      id: 0,
      name: '',
      outputValid: 0,
      monopoly: 0,
      maintain: 0,
      warn: 0,
      malfunction: 0,
      display: 0,
      Sorting: 0,
      remark: ''
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('system.workType.New_workType') : this.$t('system.workType.edit_workType')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let workType = {
        id: this.id,
        name: this.name,
        outputValid: this.outputValid,
        monopoly: this.monopoly,
        maintain: this.maintain,
        warn: this.warn,
        remark: this.remark,
        Sorting: Number(this.Sorting),
        display: Number(this.display),
        malfunction: Number(this.malfunction)
      }
      Api.workType.save(workType).then(() => {
        this.$router.push({'name': 'WorkType'})
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    let id = to.params.id
    if (id !== 0) {
      Api.workType.get(id).then(res => {
        next(vm => {
          let wt = res.workType
          vm.id = wt.id
          vm.name = wt.name
          vm.outputValid = wt.outputValid
          vm.monopoly = wt.monopoly
          vm.maintain = wt.maintain
          vm.warn = wt.warn
          vm.remark = wt.remark
          vm.display = wt.display
          vm.malfunction = wt.malfunction
          vm.Sorting = wt.Sorting
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .work-type-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?7969ab82